<template>
    <div class="main-body">
        <el-button type="primary" size="small" icon="el-icon-back" v-if="app_id" @click="goback"
                   style="margin-bottom: 1em;"></el-button>
        <h2>{{ $strings('spsite/cpapp/title') }}</h2>
        <div class="action-bar" v-if="!app_id">
            <div class="add-wrapper">
                <el-button type="primary" size="small" @click="onCreate">{{ $strings('word/create') }}</el-button>
            </div>
            <div class="filter-wrapper">
                <el-form :inline="true" :model="formFilter" class="demo-form-inline" ref="filter">
                    <el-form-item label="">
                        <FilterCp v-model="formFilter.cp_id" class="max-width-120" @load="onLoadCp"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onFilter" size="small">{{
                                $strings('word/query')
                            }}
                        </el-button>
                        <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="data-area">
            <el-table
                v-loading="loading"
                border
                :data="tableData"
                style="width: 100%">
                <el-table-column type="expand" label="∷" fixed>
                    <template slot-scope="scope">
                        <ul>
                            <li>AppID: {{ scope.row.app_id }}</li>
                            <li>AppToken: {{ scope.row.app_token }}</li>
                        </ul>
                    </template>
                </el-table-column>
                <el-table-column prop="cp_id" :label="$strings('word/cp_id')" width="100" fixed>
                    <template slot-scope="scope"><span class="code-text">{{ scope.row.cp_id }}</span></template>
                </el-table-column>
                <el-table-column prop="cp_name" :label="$strings('word/cp_name')" width="100" fixed>
                    <template slot-scope="scope"><span>{{ mapping.cps[scope.row.cp_id] }}</span></template>
                </el-table-column>
                <el-table-column prop="link_id" :label="$strings('word/link_id')" width="160"></el-table-column>
                <el-table-column prop="app_id" :label="$strings('word/app_id')" width="160"></el-table-column>
                <el-table-column prop="app_name" :label="$strings('word/app_name')" width="180"></el-table-column>
                <el-table-column prop="app_status" :label="$strings('word/app_status')" width="100">
                    <template slot-scope="scope">
                        <el-link size="small" :type="$strings('spsite/cpapp/app_status_type/' + scope.row.app_status)"
                                 :underline="false">
                            {{ $strings('spsite/cpapp/app_status/' + scope.row.app_status) }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="app_purpose" :label="$strings('word/app_purpose')" width="180"></el-table-column>
                <el-table-column prop="smpp_user" :label="$strings('word/smpp_user')" width="110"></el-table-column>
                <el-table-column prop="smpp_pass" :label="$strings('word/smpp_pass')" width="140"></el-table-column>
                <el-table-column prop="smpp_host" :label="$strings('word/smpp_host')" width="120"></el-table-column>
                <el-table-column prop="smpp_port" :label="$strings('word/smpp_port')" width="100"></el-table-column>
                <el-table-column prop="smpp_sender" :label="$strings('word/smpp_sender')" width="100"></el-table-column>
                <el-table-column prop="cb_url" :label="$strings('word/cb_url')" width="100"></el-table-column>
                <el-table-column prop="cb_method" :label="$strings('word/cb_method')" width="100"></el-table-column>
                <el-table-column prop="cb_ct" :label="$strings('word/cb_ct')" width="120"></el-table-column>
                <el-table-column prop="ct_time" label="CreateTime" width="160">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="Remark" show-overflow-tooltip></el-table-column>
                <el-table-column :label="$strings('word/edit')" width="240" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="small" @click="onEdit(scope.row)">{{ $strings('word/review') }}</el-button>
                        <el-tooltip effect="dark" content="click to copy" placement="top"
                                    v-if="scope.row.app_status === appStatus.LIVING">
                            <el-button size="small" style="cursor:pointer;" class="btn hover-underline"
                                       :data-clipboard-text="getSmppCred(scope.row)">Copy Credential
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination margin-top-1" v-if="pagination.total > pagination.size" style="text-align: right">
                <el-pagination background layout="prev, pager, next" :total="pagination.total"
                               :page-size.sync="pagination.size"
                               :current-page.sync="pagination.page" @current-change="refreshData"></el-pagination>
            </div>
        </div>
        <el-dialog
            :title="isEdit ? $strings('word/edit') : $strings('word/create')"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @closed="onClose"
            width="30%">
            <div>
                <el-form ref="form" :model="editForm" :rules="rules" label-width="80px">
                    <el-form-item :label="$strings('word/action')">
                        <el-select v-model="editForm.app_status" :placeholder="$strings('spsite/cpapp/select_action')"
                                   filterable>
                            <el-option :label="$strings('word/waiting')" :value="appStatus.CREATED"></el-option>
                            <el-option :label="$strings('word/reject')" :value="appStatus.REJECTED"></el-option>
                            <el-option :label="$strings('word/resolve')" :value="appStatus.LIVING"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="editForm.app_status*1===appStatus.LIVING" :label="$strings('word/sender')">
                        <el-select v-model="editForm.link_id">
                            <el-option v-for="(val, key) in options.senders" :key="key" :label="val.label"
                                       :value="val.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        v-show="editForm.app_status*1===appStatus.LIVING"
                        :label="$strings('word/smpp_host')">
                        <el-select v-model="editForm.smpp_host">
                            <el-option v-for="(val, idx) in options.hosts" :key="idx" :label="val"
                                       :value="val"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        v-if="editForm.app_status*1===appStatus.LIVING "
                        :label="$strings('word/smpp_port')" prop="smpp_port">
                        <el-select v-model="editForm.smpp_port" :disabled="!editForm.smpp_host">
                            <el-option v-for="(val, idx) in options.ports[editForm.smpp_host]" :key="idx" :label="val"
                                       :value="val"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        v-if="editForm.app_status*1===appStatus.LIVING "
                        :label="$strings('word/smpp_user')">
                        <el-input v-model="editForm.smpp_user" clearable maxlength="16" show-word-limit
                                  :placeholder="$strings('word/smpp_user')"></el-input>
                    </el-form-item>
                    <el-form-item
                        v-if="editForm.app_status*1===appStatus.LIVING "
                        :label="$strings('word/smpp_pass')">
                        <el-row>
                            <el-col :span="14">
                                <el-input v-model="editForm.smpp_pass" clearable maxlength="16" show-word-limit
                                          :placeholder="$strings('word/smpp_pass')"
                                          :disabled="editForm.rand_pass"></el-input>
                            </el-col>
                            <el-col :span="10" style="padding-left: 1em;">
                                <el-checkbox v-model="editForm.rand_pass">Random</el-checkbox>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item
                        v-if="editForm.app_status*1===appStatus.LIVING "
                        :label="$strings('word/smpp_sender')">
                        <el-row>
                            <el-col :span="14">
                                <el-input v-model="editForm.smpp_sender" clearable maxlength="16" show-word-limit
                                          :placeholder="$strings('word/smpp_sender')"
                                          :disabled="editForm.rand_sender"></el-input>
                            </el-col>
                            <el-col :span="10" style="padding-left: 1em;">
                                <el-checkbox v-model="editForm.rand_sender">Default</el-checkbox>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item v-if="editForm.app_status*1===appStatus.REJECTED" :label="$strings('word/remark')">
                        <el-input type="textarea" rows="4" v-model="editForm.remark" clearable maxlength="64"
                                  show-word-limit
                                  :placeholder="$strings('spsite/cpapp/prop_remark')"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $strings('word/cancel') }}</el-button>
                <el-button type="primary" @click="onSaveEdit()" :loading="saving">{{
                        $strings('word/confirm')
                    }}
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="$strings('word/create')"
            :visible.sync="createDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @closed="onClose"
            width="30%">
            <div>
                <el-form ref="form" :model="createForm" label-width="100px" :rules="rules_create">
                    <el-form-item :label="$strings('word/cp_id')" prop="cp_id">
                        <el-select v-model="createForm.cp_id">
                            <el-option v-for="(val, key) in options.cps" :key="key" :label="val.label"
                                       :value="val.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$strings('word/app_name')" prop="app_name">
                        <el-input v-model="createForm.app_name" clearable maxlength="24" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('word/app_purpose')" prop="app_purpose">
                        <el-input v-model="createForm.app_purpose" clearable maxlength="24" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item
                        :label="$strings('word/smpp_user')">
                        <el-input v-model="createForm.smpp_user" clearable maxlength="16" show-word-limit
                                  :placeholder="$strings('word/smpp_user')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('word/smpp_pass')">
                        <el-row>
                            <el-col :span="14">
                                <el-input v-model="createForm.smpp_pass" clearable maxlength="16" show-word-limit
                                          :placeholder="$strings('word/smpp_pass')"
                                          :disabled="createForm.rand_pass"></el-input>
                            </el-col>
                            <el-col :span="10" style="padding-left: 1em;">
                                <el-checkbox v-model="createForm.rand_pass">Random</el-checkbox>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createDialogVisible = false">{{ $strings('word/cancel') }}</el-button>
                <el-button type="primary" @click="onSaveCreate()" :loading="saving">{{ $strings('word/confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {SpSiteSpAppRead, SpSiteSpCpAppRead, SpSiteSpRead} from "@/api/spsite/api";
import {API_STATUS_CODE, STORAGE_KEY_LOGIN_TZ} from "@/config/config";
import {GetItem} from "@/utils/storage";
import {UnixToDateFull} from "../../../utils/time";
import FilterCp from "../../../components/filter/cp";
import {APP_STATUS} from "../../../config/config";
import ClipboardJS from "clipboard";
import {
    SpSiteCpRead,
    SpSiteSmppNodeRead,
    SpSiteSpCpAppCreate,
    SpSiteSpCpAppReject,
    SpSiteSpCpAppResolve
} from "../../../api/spsite/api";

export default {
    props: ["app_id"],
    name: "spsite-cp-app",
    components: {FilterCp},
    data() {
        return {
            loading: true,
            isEdit: false,
            saving: false,
            editForm: {},
            formFilter: {},
            tableData: [],
            createForm: {},
            dialogVisible: false,
            createDialogVisible: false,
            pagination: {
                total: 0,
                page: 1,
                size: 12,
            },
            rules: {
                smpp_port: [
                    {required: true, message: this.$strings('spsite/cp/error/remark_empty'), trigger: 'blur'}
                ]
            },
            rules_create: {
                cp_id: [
                    {required: true, message: this.$strings('spsite/cp/error/remark_empty'), trigger: 'blur'}
                ],
                app_name: [
                    {required: true, message: this.$strings('spsite/cp/error/remark_empty'), trigger: 'blur'}
                ],
                app_purpose: [
                    {required: true, message: this.$strings('spsite/cp/error/remark_empty'), trigger: 'blur'}
                ]
            },
            options: {
                senders: [],
                hosts: [],
                ports: {},
                cps: []
            },
            appStatus: APP_STATUS,
            mapping: {cps: {}, sps: {}, senders: {}},
        }
    },
    mounted() {
        this.prepareData();
        this.refreshData();
        let clipboard = new ClipboardJS('.btn');
        clipboard.on('success', function (e) {
            let content = '<textarea rows="5" style="width: 100%; padding: 1em;" class="el-textarea__inner">' + e.text + '</textarea>';
            this.$alert(content, 'Credential', {dangerouslyUseHTMLString: true});
            e.clearSelection();
        }.bind(this));
    },
    computed: {},
    beforeCreate() {
        SpSiteSpRead({page: 1, size: 100}).then(resp => {
            this.mapping.sps = {}
            resp.data.data.rows.forEach((item) => {
                this.mapping.sps[item.sp_id] = item;
            })
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
        getSmppCred(row) {
            let ret = "smpp host: " + row.smpp_host + "\n"
                + "smpp port: " + row.smpp_port + "\n"
                + "smpp system_id: " + row.smpp_user + "\n"
                + "smpp password: " + row.smpp_pass;
            if (row.smpp_sender.length > 0) {
                ret += "\n" + "smpp sender: " + row.smpp_sender;
            }
            return ret;
        },
        onLoadCp(cps) {
            this.mapping.cps = {};
            cps.forEach((item) => {
                this.mapping.cps[item.cp_id] = item.cp_name;
            })
        },
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        onFilter() {
            this.refreshData();
        },
        onReset() {
            this.formFilter.cp_id = '';
            this.refreshData();
        },
        onClose() {
            this.saving = false
            this.$refs["form"].clearValidate();
        },
        onEdit(row) {
            this.isEdit = true;
            this.editForm = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;
        },
        onCreate() {
            this.createForm = {};
            this.createDialogVisible = true;
        },
        onSaveCreate() {
            this.saving = true;
            if (this.editForm.rand_pass) {
                this.editForm.smpp_pass = (Math.random() + 1).toString(36).substring(2);
            }
            SpSiteSpCpAppCreate(this.createForm).then(() => {
                this.refreshData();
            }).finally(() => {
                this.createDialogVisible = false;
            });
        },
        prepareData() {
            SpSiteSpAppRead({no_binding: true, page: 1, size: 1000}).then((resp) => {
                this.options.senders = [];
                this.mapping.senders = {};
                resp.data.data.rows.forEach(item => {
                    this.options.senders.push({
                        label: item.sp_id + '/' + item.app_name,
                        value: item.link_id
                    });
                    this.mapping.senders[item.link_id] = item;
                })
            });
            SpSiteSmppNodeRead({is_lock: 0, page: 1, size: 100}).then((resp) => {
                this.options.hosts = [];
                this.options.ports = {};
                resp.data.data.rows.forEach(item => {
                    if (!this.options.ports[item.smpp_host]) {
                        this.options.ports[item.smpp_host] = [];
                        this.options.hosts.push(item.smpp_host);
                    }
                    this.options.ports[item.smpp_host].push(item.smpp_port);
                })
            });
            SpSiteCpRead({page: 1, size: 100}).then((resp) => {
                this.options.cps = [];
                resp.data.data.rows.forEach(item => {
                    this.options.cps.push({
                        label: item.cp_name,
                        value: item.cp_id,
                    });
                })
            });
        },
        onSaveEdit() {
            this.saving = true;
            if (this.editForm.rand_pass) {
                this.editForm.smpp_pass = (Math.random() + 1).toString(36).substring(2);
            }
            this.editForm.smpp_port = 1 * this.editForm.smpp_port;
            let action = this.editForm.app_status === this.appStatus.LIVING ? SpSiteSpCpAppResolve : SpSiteSpCpAppReject;
            action(this.editForm).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.dialogVisible = false;
                    this.isEdit = false;
                    this.refreshData();
                }
            }).finally(() => {
                this.saving = false;
            });
        },
        refreshData() {
            this.loading = true;
            this.formFilter.page = this.pagination.page;
            this.formFilter.size = this.pagination.size;
            this.formFilter.app_id = this.app_id;
            SpSiteSpCpAppRead(this.formFilter).then((resp) => {
                this.tableData = resp.data.data.rows;
                this.pagination.total = resp.data.data.total;
            }).finally(() => {
                this.loading = false;
            })
        },
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}
</style>